{
  "hero": {
    "title": "Sovereign Offset Registry",
    "subtitle": "Streamlined carbon credit management platform supporting project developers, auditors, and credit holders with comprehensive lifecycle tracking and verification.",
    "badges": {
      "article6": "Article 6 Compliant",
      "unfccc": "UNFCCC Aligned",
      "blockchain": "Blockchain Integrated"
    }
  },
  "access": {
    "title": "Choose Your Access Path",
    "subtitle": "Select your role to access specialized registration and management tools",
    "developer": {
      "title": "Project Developer",
      "description": "Submit projects, manage documentation, and track credit issuance",
      "register": "Register",
      "login": "Login"
    },
    "auditor": {
      "title": "Auditor (DOE)",
      "description": "Validate projects and provide verification services",
      "register": "Register",
      "login": "Login"
    },
    "trader": {
      "title": "Credit Holder / Trader",
      "description": "Buy, trade, and retire carbon credits",
      "register": "Register (Free)",
      "login": "Login"
    },
    "government": {
      "title": "Government / DNA",
      "description": "Administrative oversight and regulatory management",
      "register": "Register",
      "login": "Login"
    },
    "legacy": {
      "title": "Legacy Project Registration",
      "description": "For existing projects transitioning from other standards (ICS, CDM, VCS)",
      "button": "Compliance Path Registration"
    }
  },
  "announcements": {
    "title": "Latest Announcements",
    "items": {
      "doe_guidelines": {
        "title": "New DOE Accreditation Guidelines",
        "description": "Updated requirements for Designated Operational Entity registration and sectoral scope validation.",
        "date": "December 15, 2024"
      },
      "article6_update": {
        "title": "Article 6 Implementation Update",
        "description": "Enhanced cooperative approach mechanisms now available for international transfers.",
        "date": "December 10, 2024"
      },
      "maintenance": {
        "title": "System Maintenance Notice",
        "description": "Scheduled maintenance on December 20, 2024 from 2:00-4:00 AM UTC.",
        "date": "December 8, 2024"
      }
    }
  },
  "downloads": {
    "title": "Document Downloads",
    "items": {
      "pin_template": "PIN Template",
      "pdd_template": "PDD Template",
      "npramp_guide": "NPRAMP Guide",
      "user_manual": "User Manual"
    }
  },
  "explorer": {
    "title": "Registry Explorer",
    "subtitle": "Browse active projects and credit transactions",
    "filters": {
      "all_categories": "All Categories",
      "all_status": "All Status",
      "search_button": "Search Registry"
    },
    "stats": {
      "active_projects": "Active Projects",
      "credits_issued": "Credits Issued",
      "credits_retired": "Credits Retired"
    }
  }
}